import DynamicSvgComponent from "./DynamicSvgComponent";

export default DynamicSvgComponent;
